import React from 'react';
import { CSSProperties } from 'styled-components';
import JackPotInstruct from "../../../assets/jackpot-instruct.png"

interface JackpotInstructProps{
style: CSSProperties;
}

const JackpotInstruct: React.FC<JackpotInstructProps> = ({style}) => {
  return (
    <img src={JackPotInstruct} alt="Jackpot Instruction" style={{ ...style}}/>
  );
};

export default JackpotInstruct;
